module.exports = __webpack_public_path__ + "static/media/very-motivated.a114105f.svg";